var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-nav-wapper"
  }, [_vm.$themeConfig.pageButton !== false && (_vm.prev || _vm.next) ? _c('div', {
    staticClass: "page-nav-centre-wrap"
  }, [_vm.prev ? _c('router-link', {
    staticClass: "page-nav-centre page-nav-centre-prev",
    attrs: {
      "to": _vm.prev.path
    },
    nativeOn: {
      "mouseenter": function ($event) {
        return _vm.showTooltip($event);
      },
      "mousemove": function ($event) {
        return _vm.showTooltip($event);
      }
    }
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.prev.title || _vm.prev.path))])]) : _vm._e(), _vm._v(" "), _vm.next ? _c('router-link', {
    staticClass: "page-nav-centre page-nav-centre-next",
    attrs: {
      "to": _vm.next.path
    },
    nativeOn: {
      "mouseenter": function ($event) {
        return _vm.showTooltip($event);
      },
      "mousemove": function ($event) {
        return _vm.showTooltip($event);
      }
    }
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.next.title || _vm.next.path))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.prev || _vm.next ? _c('div', {
    staticClass: "page-nav"
  }, [_c('p', {
    staticClass: "inner"
  }, [_vm.prev ? _c('span', {
    staticClass: "prev"
  }, [_vm._v("\n        ←\n        "), _vm.prev ? _c('router-link', {
    staticClass: "prev",
    attrs: {
      "to": _vm.prev.path
    }
  }, [_vm._v(_vm._s(_vm.prev.title || _vm.prev.path))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.next ? _c('span', {
    staticClass: "next"
  }, [_vm.next ? _c('router-link', {
    attrs: {
      "to": _vm.next.path
    }
  }, [_vm._v(_vm._s(_vm.next.title || _vm.next.path))]) : _vm._e(), _vm._v("→\n      ")], 1) : _vm._e()])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };